import Vue from 'vue'
import App from './App.vue'
import VueResource from 'vue-resource'
import VueRouter from 'vue-router'
import firebase from 'firebase'
import {store} from './store/store'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import VueQRCodeComponent from 'vue-qrcode-component'

// Register the Vue component
Vue.component('qr-code', VueQRCodeComponent)
//import { initializeApp } from "firebase/app";

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue'


Vue.use(BootstrapVue)

Vue.use(IconsPlugin)

Vue.use(VueResource)
Vue.use(VueRouter)


Vue.config.productionTip = false

import Dashboard from './components/dashboard.vue';
import userProfile from './components/userinfo.vue';
import organization from './components/organization.vue';
import Login from './components/login.vue';
import SignUp from './components/Signup.vue';

const router = new VueRouter({
    mode: 'history',
    base: __dirname,
    routes:[
      {path: '/dashboard', name: 'dashboard', component: Dashboard},
      {path: '/UserProfile/:id', name: 'userProfile', component: userProfile},
      {path: '/organization/:id', name: 'organization', component: organization},
      {path: '/', name: 'login', component: Login},
      {path: '/signup', name: 'signup', component: SignUp}
    ]
})


const firebaseConfig = {
  apiKey: "AIzaSyCaI790OQFEVmYe0Z6Exy0GXUd5MxXFpIQ",
  authDomain: "id-verifier-41bb8.firebaseapp.com",
  projectId: "id-verifier-41bb8",
  storageBucket: "id-verifier-41bb8.appspot.com",
  messagingSenderId: "949768051250",
  appId: "1:949768051250:web:23d01cbc71bbfac2cd7a2b"
};

firebase.initializeApp(firebaseConfig);

new Vue({
  el: '#app',
  store: store,
  router: router,
  render: h => h(App)
})